import {
    INIT_USER_INFO,
} from '../actions/actions';

const initial_info = {
    id: "",
    workspaceList: [],
};


export default function userReducer(state = initial_info, action) {
    if (action.type === INIT_USER_INFO) {
        return action.data
    }

    return state;
}
